( function () {
	"use strict";

	function qs( sel, ctx ) {
		return ( ctx || document ).querySelector( sel );
	}

	function qsa( sel, ctx ) {
		return Array.from(
			( ctx || document ).querySelectorAll( sel )
		);
	}

	function esc( s ) {
		return String( s )
			.replace( /&/g, "&amp;" )
			.replace( /</g, "&lt;" )
			.replace( />/g, "&gt;" )
			.replace( /"/g, "&quot;" );
	}

	function toSlug( str ) {
		return String( str )
			.toLowerCase()
			.replace( /[\s_]+/g, "-" );
	}

	qsa( ".avb-section" ).forEach( function ( section ) {

		const selectedPageUrl =
			section.dataset.selectedPage || "";

		const overlay = qs(
			".avb-modal-overlay",
			section
		);

		const modal = qs(
			".avb-modal",
			section
		);

		const closeBtn = qs(
			".avb-modal-close",
			section
		);

		const accHeader = qs(
			".avb-modal-acc-header",
			section
		);

		const accBody = qs(
			".avb-modal-acc-body",
			section
		);

		const accArrow = qs(
			".avb-modal-acc-arrow",
			section
		);

		if ( overlay ) {
			document.body.appendChild( overlay );
		}

		( function persistFilterConfig() {

			const labels = [];

			qsa(
				".avb-filter-btn",
				section
			).forEach( function ( btn ) {

				if (
					btn.dataset.filter &&
					btn.dataset.filter !== "*"
				) {
					labels.push(
						btn.dataset.filter
					);
				}
			} );

			const showAllBtn = qs(
				'.avb-filter-btn[data-filter="*"]',
				section
			);

			try {

				localStorage.setItem(
					"avb_filter_config",
					JSON.stringify( {
						filters: labels,
						showAll: showAllBtn
							? showAllBtn.textContent.trim()
							: "Show All",
						listingUrl:
							window.location.origin +
							window.location.pathname,
					} )
				);

			} catch ( e ) {}
		} )();

		const searchInput = qs(
			".avb-search-input",
			section
		);

		const noResults = qs(
			".avb-no-results",
			section
		);

		const filterBtns = qsa(
			".avb-filter-btn",
			section
		);

		function applyFilters() {

			// Collect all active non-"show-all" filters
			const activeFilters = [];
			filterBtns.forEach( function ( btn ) {
				if (
					btn.classList.contains( "avb-filter-active" ) &&
					btn.dataset.filter &&
					btn.dataset.filter !== "*"
				) {
					activeFilters.push( btn.dataset.filter.toLowerCase() );
				}
			} );

			const showAll = activeFilters.length === 0;

			const searchVal = searchInput
				? searchInput.value.toLowerCase().trim()
				: "";

			let visible = 0;

			qsa( ".vrb-card", section ).forEach( function ( card ) {

				let data = {};
				try {
					data = JSON.parse( card.dataset.card || "{}" );
				} catch ( e ) {}

				const title = ( data.cardTitle || "" ).toLowerCase();
				const desc  = ( data.shortDescription || "" ).toLowerCase();
				const badges =
					Array.isArray( data.badgeLabels ) && data.badgeLabels.length
						? data.badgeLabels.map( ( b ) => b.toLowerCase() )
						: data.badgeLabel
						? [ data.badgeLabel.toLowerCase() ]
						: [];

				// OR logic: card matches if it matches ANY active filter
				const filterMatch =
					showAll ||
					activeFilters.some( ( f ) => badges.some( ( b ) => b === f ) );

				const badgeText   = badges.join( " " );
				const searchMatch =
					! searchVal ||
					title.includes( searchVal ) ||
					desc.includes( searchVal ) ||
					badgeText.includes( searchVal );

				card.style.display = filterMatch && searchMatch ? "" : "none";
				if ( filterMatch && searchMatch ) { visible++; }
			} );

			if ( noResults ) {
				noResults.textContent = visible === 0 ? "No roles found." : "";
			}
		}

		filterBtns.forEach( function ( btn ) {

			btn.addEventListener(
				"click",
				function () {

					// Single-select: deactivate all, activate clicked
					filterBtns.forEach( function ( b ) {
						b.classList.remove( "avb-filter-active" );
					} );
					btn.classList.add( "avb-filter-active" );
					applyFilters();
				}
			);
		} );

		if ( searchInput ) {
			searchInput.addEventListener(
				"input",
				applyFilters
			);
		}

		( function activateUrlFilter() {

			let presetRaw = "";
			try {
				presetRaw =
					new URLSearchParams( window.location.search ).get( "filter" ) || "";
			} catch ( e ) {}

			if ( ! presetRaw ) { return; }

			try {
				history.replaceState( {}, "", window.location.pathname );
			} catch ( e ) {}

			// Split preset slugs from the URL parameter
			const presets = presetRaw
				.split( "," )
				.map( ( s ) => s.trim().toLowerCase() )
				.filter( Boolean );

			const showAllBtn = qs( '.avb-filter-btn[data-filter="*"]', section );

			let matched = false;
			filterBtns.forEach( function ( btn ) {
				if ( btn.dataset.filter && btn.dataset.filter !== "*" ) {
					// Prefer data-slug (exact WP term slug) for matching.
					// Falls back to toSlug(data-filter) for buttons without data-slug.
					const btnSlug = ( btn.dataset.slug || toSlug( btn.dataset.filter ) ).toLowerCase();
					if ( presets.indexOf( btnSlug ) !== -1 ) {
						// Deactivate "show all" first time we get a match
						if ( ! matched && showAllBtn ) {
							showAllBtn.classList.remove( "avb-filter-active" );
						}
						btn.classList.add( "avb-filter-active" );
						matched = true;
					}
				}
			} );

			if ( ! matched && showAllBtn ) {
				showAllBtn.classList.add( "avb-filter-active" );
			}

			applyFilters();
		} )();

		/* ── "More Filters" expand/collapse (replaces horizontal scrolling) ─── */
		( function initFilterExpand() {

			const btnsEl = qs( '.avb-filter-btns', section );
			const toggle = qs( '.avb-filter-more-toggle', section );

			if ( ! btnsEl || ! toggle ) { return; }

			let expanded = false;
			let rowHeight = 0;

			function measureRowHeight() {
				const firstBtn = btnsEl.querySelector( '.avb-filter-btn' );
				return firstBtn ? firstBtn.offsetHeight : btnsEl.clientHeight;
			}

			function refresh() {
				rowHeight = measureRowHeight();

				if ( expanded ) {
					btnsEl.style.maxHeight = btnsEl.scrollHeight + 'px';
					return;
				}

				btnsEl.style.maxHeight = rowHeight + 'px';

				// Only show the toggle if the pills actually overflow one row.
				const overflows = btnsEl.scrollHeight > rowHeight + 2;
				toggle.classList.toggle( 'avb-filter-more-hidden', ! overflows );
			}

			toggle.addEventListener( 'click', function () {
				expanded = ! expanded;
				toggle.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
				toggle.setAttribute(
					'aria-label',
					expanded ? 'Show fewer filters' : 'Show more filters'
				);

				if ( expanded ) {
					btnsEl.style.maxHeight = btnsEl.scrollHeight + 'px';
				} else {
					btnsEl.style.maxHeight = rowHeight + 'px';
				}
			} );

			/* Re-measure after a filter click in case reflow changes overflow */
			filterBtns.forEach( function ( btn ) {
				btn.addEventListener( 'click', function () {
					requestAnimationFrame( refresh );
				} );
			} );

			/* Initial state — defer one frame so layout is complete */
			requestAnimationFrame( refresh );

			/* Re-check on resize (orientation change etc.) */
			window.addEventListener( 'resize', refresh, { passive: true } );

		} )();

		function goToSelectedPage(
			cardData
		) {

			const filterLabels = [];

			qsa(
				".avb-filter-btn",
				section
			).forEach( function ( b ) {

				if (
					b.dataset.filter &&
					b.dataset.filter !== "*"
				) {
					filterLabels.push(
						b.dataset.filter
					);
				}
			} );

			const showAllBtn = qs(
				'.avb-filter-btn[data-filter="*"]',
				section
			);

			const showAllLabel =
				showAllBtn
					? showAllBtn.textContent.trim()
					: "Show All";

			const activeBtn = qs(
				".avb-filter-btn.avb-filter-active",
				section
			);

			const activeFilter = activeBtn
				? activeBtn.dataset.filter ||
				  "*"
				: "*";

			const payload = JSON.parse(
				JSON.stringify( cardData )
			);

			payload._avb_filters =
				filterLabels;

			payload._avb_all_label =
				showAllLabel;

			try {

				localStorage.setItem(
					"avb_selected_card",
					JSON.stringify(
						payload
					)
				);

			} catch ( e ) {}

			let target =
				cardData.detailPageUrl ||
				selectedPageUrl;

			if ( ! target ) {
				return;
			}

			if (
				activeFilter &&
				activeFilter !== "*"
			) {

				target +=
					(
						target.indexOf(
							"?"
						) === -1
							? "?"
							: "&"
					) +
					"filter=" +
					toSlug(
						activeFilter
					);
			}

			window.location.href =
				target;
		}

		qsa(
			".vrb-card-apply-btn",
			section
		).forEach( function ( btn ) {

			btn.addEventListener(
				"click",
				function ( e ) {

					e.stopPropagation();

					const card =
						btn.closest(
							".vrb-card"
						);

					if ( ! card ) {
						return;
					}

					try {

						const data =
							JSON.parse(
								card.dataset
									.card || "{}"
							);

						const applyLink =
							data.applyLink || "";

						if ( applyLink && applyLink !== "#" ) {
							window.open( applyLink, "_blank" );
						} else {

							const target =
								data.detailPageUrl ||
								selectedPageUrl;

							if ( target ) {
								goToSelectedPage( data );
							}
						}

					} catch ( err ) {}
				}
			);
		} );

		/* ── Card click → open modal ──────────────────────────────────── */
		qsa( ".vrb-card", section ).forEach( function ( card ) {

			card.addEventListener(
				"click",
				function ( e ) {

					/* Let apply-btn handle its own click via stopPropagation */
					if (
						e.target.closest(
							".vrb-card-apply-btn"
						)
					) {
						return;
					}

					try {
						openModal(
							JSON.parse(
								card.dataset.card ||
									"{}"
							)
						);
					} catch ( err ) {}
				}
			);
		} );

		/* ── Time-row click → open modal ──────────────────────────────── */
		qsa( ".vrb-card-time-row", section ).forEach( function ( row ) {

			row.addEventListener(
				"click",
				function ( e ) {

					e.stopPropagation();

					const card =
						row.closest( ".vrb-card" );

					if ( ! card ) {
						return;
					}

					try {
						openModal(
							JSON.parse(
								card.dataset.card ||
									"{}"
							)
						);
					} catch ( err ) {}
				}
			);

			/* Keyboard: Enter / Space also open modal */
			row.addEventListener(
				"keydown",
				function ( e ) {

					if (
						e.key === "Enter" ||
						e.key === " "
					) {
						e.preventDefault();
						row.click();
					}
				}
			);
		} );

		function openModal( data ) {

			if (
				! overlay ||
				! modal
			) {
				return;
			}

			const iconWrap = qs(
				".avb-modal-icon-wrap",
				modal
			);

			if ( iconWrap ) {

				iconWrap.innerHTML =
					data.iconUrl
						? `<img src="${ esc(
								data.iconUrl
						  ) }" alt="${ esc(
								data.iconAlt ||
									""
						  ) }" class="w-full h-full object-cover block rounded-xl" />`
						: `<span class="flex items-center justify-center w-full h-full bg-[#f3f6f9] rounded-xl">
							<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#429cbb" stroke-width="1.4">
								<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
								<circle cx="9" cy="7" r="4"/>
							</svg>
						</span>`;
			}

			const titleEl = qs(
				".avb-modal-title",
				modal
			);

			if ( titleEl ) {
				titleEl.textContent =
					data.cardTitle || "";
			}

			const descEl = qs(
				".avb-modal-desc",
				modal
			);

			if ( descEl ) {
				descEl.textContent =
					data.shortDescription ||
					"";
			}

			/* ── Badges (all labels) ───────────────────────────────────── */
			const badgeWrap = qs( ".avb-modal-badge-wrap", modal );
			if ( badgeWrap ) {
				const labels =
					( Array.isArray( data.badgeLabels ) && data.badgeLabels.length )
						? data.badgeLabels
						: ( data.badgeLabel ? [ data.badgeLabel ] : [] );
				badgeWrap.innerHTML = labels
					.map( ( l ) => `<span class="avb-modal-badge">${ esc( l ) }</span>` )
					.join( "" );
			}

			/* ── About the Role ─────────────────────────────────────────── */
			const aboutSec = qs(
				".avb-modal-about-sec",
				modal
			);
			const aboutList = qs(
				".avb-modal-about-list",
				modal
			);

			if ( aboutList ) {
				const lines = (
					data.aboutRole || ""
				)
					.split( "\n" )
					.filter( Boolean );

				aboutList.innerHTML = lines
					.map(
						( l ) =>
							`<li>${ esc( l ) }</li>`
					)
					.join( "" );

				if ( aboutSec ) {
					aboutSec.style.display =
						lines.length > 0
							? ""
							: "none";
				}
			}

			/* ── Time Details ───────────────────────────────────────────── */
			const timeSec = qs(
				".avb-modal-time-sec",
				modal
			);
			const timeEl = qs(
				".avb-modal-time-val",
				modal
			);

			if ( timeEl ) {
				timeEl.textContent =
					data.timeDetails || "";

				if ( timeSec ) {
					timeSec.style.display =
						data.timeDetails ? "" : "none";
				}
			}

			/* ── Location ───────────────────────────────────────────────── */
			const locSec = qs(
				".avb-modal-loc-sec",
				modal
			);
			const locEl = qs(
				".avb-modal-loc-val",
				modal
			);

			if ( locEl ) {
				locEl.textContent =
					data.locationDetails || "";

				if ( locSec ) {
					locSec.style.display =
						data.locationDetails
							? ""
							: "none";
				}
			}

			/* ── Commitment ─────────────────────────────────────────────── */
			const commitSec = qs(
				".avb-modal-commit-sec",
				modal
			);
			const commitEl = qs(
				".avb-modal-commit-val",
				modal
			);

			if ( commitEl ) {
				commitEl.textContent =
					data.commitmentDetails || "";

				if ( commitSec ) {
					commitSec.style.display =
						data.commitmentDetails
							? ""
							: "none";
				}
			}

			/* ── About Task ─────────────────────────────────────────────── */
			const taskSec = qs( ".avb-modal-task-sec", modal );
			const taskEl  = qs( ".avb-modal-task-val", modal );
			if ( taskEl ) {
				taskEl.textContent = data.aboutTask || "";
				if ( taskSec ) {
					taskSec.style.display = data.aboutTask ? "" : "none";
				}
			}

			/* ── Skills Needed ───────────────────────────────────────────── */
			const skillsSec  = qs( ".avb-modal-skills-sec", modal );
			const skillsList = qs( ".avb-modal-skills-list", modal );
			if ( skillsList ) {
				const skills = ( data.skillsNeeded || "" )
					.split( "," )
					.map( ( s ) => s.trim() )
					.filter( Boolean );
				skillsList.innerHTML = skills
					.map( ( s ) => `<li>${ esc( s ) }</li>` )
					.join( "" );
				if ( skillsSec ) {
					skillsSec.style.display =
						skills.length > 0 ? "" : "none";
				}
			}

			/* ── Tools ───────────────────────────────────────────────────── */
			const toolsSec  = qs( ".avb-modal-tools-sec", modal );
			const toolsList = qs( ".avb-modal-tools-list", modal );
			if ( toolsList ) {
				const tools = ( data.toolsNeeded || "" )
					.split( "," )
					.map( ( t ) => t.trim() )
					.filter( Boolean );
				toolsList.innerHTML = tools
					.map( ( t ) => `<li>${ esc( t ) }</li>` )
					.join( "" );
				if ( toolsSec ) {
					toolsSec.style.display =
						tools.length > 0 ? "" : "none";
				}
			}

			/* ── Apply button ───────────────────────────────────────────── */
			const applyBtn = qs(
				".avb-modal-apply-btn",
				modal
			);

			if ( applyBtn ) {
				const isExternal = !! ( data.applyLink && data.applyLink !== "#" );
				applyBtn.href        = isExternal ? data.applyLink : ( data.detailPageUrl || selectedPageUrl || "#" );
				applyBtn.target      = isExternal ? "_blank" : "_self";
				applyBtn.rel         = isExternal ? "noopener noreferrer" : "";
				applyBtn.textContent = ( data.applyText || "Submit test assignment" ).toUpperCase();
			}

			if ( accBody ) {

				accBody.style.display =
					"flex";

				accBody.classList.add(
					"avb-acc-open"
				);
			}

			if ( accArrow ) {

				accArrow.classList.add(
					"avb-acc-rotated"
				);
			}

			if ( accHeader ) {

				accHeader.setAttribute(
					"aria-expanded",
					"true"
				);
			}

			overlay.style.display =
				"flex";

			overlay.classList.add(
				"avb-modal-open"
			);

			overlay.setAttribute(
				"aria-hidden",
				"false"
			);

			document.body.style.overflow =
				"hidden";

			const scrollEl = qs(
				".avb-modal-scroll",
				modal
			);

			if ( scrollEl ) {
				scrollEl.scrollTop = 0;
			}
		}

		function closeModal() {

			if ( ! overlay ) {
				return;
			}

			overlay.classList.remove(
				"avb-modal-open"
			);

			overlay.style.display =
				"none";

			overlay.setAttribute(
				"aria-hidden",
				"true"
			);

			document.body.style.overflow =
				"";
		}

		if ( overlay ) {

			overlay.addEventListener(
				"click",
				function ( e ) {

					if (
						e.target ===
						overlay
					) {
						closeModal();
					}
				}
			);
		}

		if ( closeBtn ) {

			closeBtn.addEventListener(
				"click",
				closeModal
			);
		}

		document.addEventListener(
			"keydown",
			function ( e ) {

				if (
					e.key ===
						"Escape" &&
					overlay &&
					overlay.classList.contains(
						"avb-modal-open"
					)
				) {
					closeModal();
				}
			}
		);

		if ( accHeader ) {

			accHeader.addEventListener(
				"click",
				function () {

					const open =
						accBody &&
						accBody.classList.contains(
							"avb-acc-open"
						);

					if ( open ) {

						if ( accBody ) {

							accBody.classList.remove(
								"avb-acc-open"
							);

							accBody.style.display =
								"none";
						}

						if ( accArrow ) {

							accArrow.classList.remove(
								"avb-acc-rotated"
							);
						}

						accHeader.setAttribute(
							"aria-expanded",
							"false"
						);

					} else {

						if ( accBody ) {

							accBody.style.display =
								"flex";

							accBody.classList.add(
								"avb-acc-open"
							);
						}

						if ( accArrow ) {

							accArrow.classList.add(
								"avb-acc-rotated"
							);
						}

						accHeader.setAttribute(
							"aria-expanded",
							"true"
						);
					}
				}
			);
		}

	} );

} )();